import * as React from 'react';
import * as $ from 'jquery';

import { IGlob } from '../../../_common/application/ts/Glob';
import { AttrQueryKPIFieldComponent } from '../../../_common/application/tsx/AttrQueryKPIField';
import { IPopupOptions } from '../../../pdc-platform/src/ts/actions/DialogActions';

const reactGlobalClick = require('../../../_common/platform/ts/reactGlobalClick');

interface IDefineQueryPopupOptions extends IPopupOptions {
    value;
    themeObj; //LL: 06.02.20
    onChange(value): void;
}

//LL: see ColorBoxField.tsx
//LL: see IntervalsSelect.tsx  IntervalSelectPopup
export class DefineQueryPopup extends React.Component<
    {
        zIndex: number;

        //LL:  value is Query or [Query]  ?   from AttrQueryKPIField
        options: IDefineQueryPopupOptions;

        close(): void;

        glob: IGlob;
    },
    {
        value;
    }
> {
    constructor(props) {
        super(props);

        //const valueOrig = $.extend(true, {}, this.props.options.value);
        //this.state = {
        //    value: valueOrig
        //};

        this.state = {
            value: this.props.options.value
        };
    }

    private globalClickIndex = 0; //LL: was in IntervalsSelect

    componentDidMount() {
        //LL: was in IntervalsSelect:
        this.globalClickIndex = reactGlobalClick.register(this.props.close);
    }

    componentWillUnmount() {
        //LL: was in IntervalsSelect:
        reactGlobalClick.unregister(this.globalClickIndex);
        delete this.globalClickIndex;
    }

    handleKeyDown = (e) => {
        //console.log("handleKeyDown " + e);
        // enter:  e.which = 13, e.keyCode = 13, e.key = "Enter"
        // esc: e.which = 27, e.keyCode = 27, e.key = "Escape"
        switch (e.code) {
            case 'Enter': // e.key = "Enter"
                //console.log("handleKeyDown Enter");
                e.stopPropagation();
                e.preventDefault();

                this.applyButtonHandler();
                break;

            case 'Escape': // e.key = "Escape"
                //console.log("handleKeyDown Enter");
                e.stopPropagation();
                e.preventDefault();

                this.cancelButtonHandler();
                break;
        }
    };

    applyButtonHandler = () => {
        if (typeof this.props.options.onChange === 'function') {
            this.props.options.onChange(this.state.value);
        }

        this.props.close();
    };

    cancelButtonHandler = () => {
        this.props.close();
    };

    handleQueryChange = (value) => {
        //LL: value is array[]  of { attribute, filter, ...}
        //console.log("handleQueryChange");
        this.setState({ value: value });
    };

    render() {
        let style: any = {
            display: 'block',
            //height: "200px", // try for CreateDialog   WRONG, must be upper
            //left: this.props.options.offset.left + 16,  //  in IntervalsSelect
            //top: this.props.options.offset.top - 215 //  in IntervalsSelect
            left: this.props.options.left,
            top: this.props.options.top,
            zIndex: this.props.zIndex
        };

        let popupTitle = 'Define Data Query';

        let value: any = this.state.value;
        if (value == null) {
            value = [];
        }

        return (
            <div className={'define-query-popup'} onKeyDown={this.handleKeyDown}>
                <div
                    className="popover define-query-popover bs-popover-right"
                    style={style}
                    //onClick={this.containerClick}
                    onKeyDown={this.handleKeyDown}
                >
                    <h3 className="popover-header">
                        {popupTitle}
                        <button
                            type="button"
                            className="close"
                            title="Cancel all changes"
                            onClick={this.cancelButtonHandler}
                        >
                            ×
                        </button>
                    </h3>
                    <div id="color" className="popover-body colorSelectContainer">
                        <AttrQueryKPIFieldComponent
                            value={value}
                            dataSourceID={25}
                            options={{
                                singleRow: true,
                                hideFormatSetting: true, //LL: format is not needed
                                hideValueType: true,
                                hasLabel: true
                            }}
                            theme={this.props.options.themeObj}
                            glob={this.props.glob}
                            onChange={this.handleQueryChange}
                        />
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-success" onClick={this.applyButtonHandler}>
                            {'OK'}
                        </button>
                        <button className="btn btn-default" onClick={this.cancelButtonHandler}>
                            {'Cancel'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export class DataQuerySingleValueField extends React.Component<
    {
        value?: any;

        title?: string;

        disabled?: boolean; //   def false
        readOnly?: boolean; //   def false

        themeObj?: any; //LL 22.09.18  when pure tsx without ts from main (in that case is already in props)

        maxColorWidth?: string; // as "15px", //"1rem",  //LL: 11.09.18

        //LL: when called by .ts
        options?: {
            title?: string;

            disabled?: boolean; //   def false
            readOnly?: boolean; //   def false

            //LL: 20.09.18: use these when value == null (set it in main)
            themeFieldForDefault_color?: string; // use this.props.themeObj[themeFieldForDefault_color]
            defaultColor?: any; //string;

            maxColorWidth?: string; // as "15px", //"1rem",  //LL: 11.09.18

            smallField?: boolean; //   def false   //LL: 28.10.19
        };

        onChange?(value: any);

        glob: IGlob;
    },
    any
> {
    private references: {
        container?: HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);
    }

    // componentDidMount() {
    // }

    // componentDidUpdate(prevProps, prevState) {
    //     let value = this.props.value;
    // }

    public static validateQuery(value) {
        //LL: value = array of { attribute: {  aggregateGroup: "max", limit: 0, attribute: "Product.Obsolete", label: "KKKKKKKKK"}, dataSourceID, filter }
        //        label optional

        if (value == null || value.length === 0) {
            return false;
        }

        let query = value[0];
        //if (query.attribute == null || query.attribute.attribute == null) return false;
        if (query.attribute == null) {
            return false;
        }
        if (query.attribute.attribute == null && query.attribute.expression == null) {
            return false;
        }

        return true;
    }

    //LL: 30.10.19:  to use in Themes for Strip/ConstLines validators
    public static validateQuery_AllowNull(value) {
        //LL: value = array of { attribute: {  aggregateGroup: "max", limit: 0, attribute: "Product.Obsolete", label: "KKKKKKKKK"}, dataSourceID, filter }
        //        label optional

        if (value == null || value.length === 0) {
            return true;
        } //LL: Allow Null

        let query = value[0];
        //if (query.attribute == null || query.attribute.attribute == null) return false;
        if (query.attribute == null) {
            return false;
        }
        if (query.attribute.attribute == null && query.attribute.expression == null) {
            return false;
        }

        return true;
    }

    getDisabled = (props) => {
        let disabled = props.options != null ? props.options.disabled : props.disabled;
        if (disabled == null) {
            disabled = false;
        }
        return disabled;
    };

    getReadOnly = (props) => {
        let readOnly = props.options != null ? props.options.readOnly : props.readOnly;
        if (readOnly == null) {
            readOnly = false;
        }
        return readOnly;
    };

    getMaxColorWidth = (props) => {
        let maxColorWidth = props.options != null ? props.options.maxColorWidth : props.maxColorWidth;
        return maxColorWidth; // may be null
    };

    getContainer() {
        return $(this.references.container);
    }

    getTitle() {
        const title = this.props.options != null ? this.props.options.title : this.props.title;
        if (title == null || title === '') {
            return;
        }

        return <label>{title}</label>;
    }

    handleChangeQuery = (value) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    onClickQuery = (e) => {
        let disabled = this.getDisabled(this.props);
        let readOnly = this.getReadOnly(this.props);
        if (disabled || readOnly) {
            e.stopPropagation();
            e.preventDefault();
            return;
        }

        let value = this.props.value;

        this.props.glob.DialogActions.createPopup<IDefineQueryPopupOptions>('custom', {
            top: $(window).height() / 4,
            left: $(window).width() / 4,
            value: value, //this.props.value,
            themeObj: this.props.themeObj, //LL: 06.02.20
            onChange: this.handleChangeQuery,

            component: DefineQueryPopup //LL: as IntervalSelectPopup,
        });
    };

    handleClearValue = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(null);
        }
    };

    queryToString = (value) => {
        if (value == null || value.length === 0) {
            return 'not set';
        }

        let query = value[0];
        if (query.attribute == null || query.attribute.attribute == null) {
            return 'not defined';
        }

        let str = query.attribute.label;
        if (str != null) {
            str = str.trim();
        }
        if (str == null || str === '') {
            str =
                query.attribute.attribute +
                (query.attribute.aggregateGroup != null ? '.' + query.attribute.aggregateGroup : '');
        }
        return str;
    };

    validateValue = (value) => {
        return DataQuerySingleValueField.validateQuery(value);
    };

    render() {
        const value = this.props.value; //LL: it is array[1] or null

        let isDefined = value != null;
        let isValid = this.validateValue(value);

        let wrong = !isValid && isDefined;

        let title = isDefined ? this.queryToString(value) : 'not set';
        if (wrong) {
            title += ', wrong Query';
        }

        //LL: 28.10.19:
        let smallField = false;
        if (this.props.options != null && this.props.options.smallField != null) {
            smallField = this.props.options.smallField;
        }

        let text = isDefined ? (isValid ? 'Update Query' : 'Wrong Query') : 'Define Query';
        //LL: 28.10.19:
        if (smallField === true) {
            text = 'Query';
        }

        let clearButton;
        if (isDefined === true) {
            clearButton = (
                <div
                    className="glyphicon glyphicon-remove clear-button"
                    onClick={(e) => this.handleClearValue(e)}
                    title={'set default value'}
                ></div>
            );
        }

        let style1: any = {
            display: 'flex'
        };

        let style2: any = {
            backgroundColor: '#dddddd'
        };

        let maxColorWidth = this.getMaxColorWidth(this.props);
        if (maxColorWidth != null) {
            style2.maxWidth = maxColorWidth;
        }

        if (wrong) {
            style2.color = 'red';
        }

        if (smallField === true) {
            if (!isDefined) {
                style2.border = 'solid 1px #80d8ff'; //  ~~blue
            }
        }

        return (
            <div
                className="form-control dataquerysinglevalue-field"
                style={style1}
                onClick={this.onClickQuery}
                title={title}
            >
                {clearButton}
                <div
                    style={style2}
                    className="dataquery-container"
                    ref={(input) => {
                        this.references.container = input;
                    }}
                >
                    {text}
                </div>
            </div>
        );
    }
}
